export default "__VITE_ASSET__1d0KQ4ro__"